<template>
  <FormContainer @submitForm="submit">
    <FeedbackAlert v-if="feedback === false">Errore nel salvataggio dei dati! Riprovare</FeedbackAlert>

    <div class="row">
      <ImagePreview class="col-auto" v-for="file in files" :image="file" :key="file.code" @remove="removeFile" @replace="replaceFile" />
      <div class="col-12">
        <Uploader ref="uploader" :max="maxFiles" v-model="files" :uploadApiEndpoint="startUpload" :allowedFiles="['image/*']">
          Seleziona immagine
        </Uploader>
      </div>
    </div>

    <div class="row">
      <MarkdownEditorWidget
        class="col-lg-12"
        label="Descrizione"
        v-model="note.description"
        :errorMsg="errorHash.description"
        @input="removeFieldError('description')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 d-flex justify-content-between">
        <div>
          <button class="btn btn-outline-danger font-weight-bold" @click.prevent="$emit('removeNote', $event)" v-if="edit">Cancella tutorial</button>
        </div>
        <button class="btn btn-primary px-5 font-weight-bold">Salva</button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';
import uploadFilesMixin from '@/libs/Uploader/mixins/uploadFiles';

import MarkdownEditorWidget from '@/views/components/Form/Widgets/MarkdownEditorWidget.vue';

export default {
  mixins: [uploadFilesMixin, validateMixin],
  components: {
    FormContainer: () => import('@/views/components/Form/FormContainer'),
    FeedbackAlert: () => import('@/libs/Feedback/components/Alert'),
    Uploader: () => import('@/libs/Uploader/components/Uploader'),
    ImagePreview: () => import('@/libs/Uploader/components/ImagePreview'),
    MarkdownEditorWidget,
  },
  props: {
    note: {
      type: Object,
      default: () => ({
        description: null,
        images: [],
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: Boolean,
      default: null,
    },
  },
  data () {
    return {
      files: this.note?.images ? [...this.note.images] : [],
    };
  },
  methods: {
    removeFieldError (field) {
      this.removeFeedback();
      this.removeError(field);
    },
    removeFeedback () {
      this.$emit('update:feedback', null);
    },
    isValid () {
      this.clearErrors();
      this.removeFeedback();

      if (!this.note.description) {
        this.addError('Inserire la descrizione', 'description');
      }

      return !this.hasErrors;
    },
    submit () {
      this.clearErrors();
      this.removeFeedback();

      if (!this.isValid()) {
        return;
      }

      if (!this.uploadsFinishedAndReadyToSubmit()) {
        this.addError('images', 'Caricamento immagini in corso');

        return;
      }

      const noteToReturn = { ...this.note };
      noteToReturn.images = this.filesToSubmit.length > 0 ? [...this.filesToSubmit] : [];

      this.$emit('submitForm', noteToReturn);
    },
  },
  watch: {
    'note.images': function (newValue) {
      this.files = newValue ? [...newValue] : [];
    },
  },
};

</script>
